import React, { useContext } from 'react';

import AppContext from 'contexts/AppContext';
import Button from 'components/buttons/Button';

function PoiSuggestionSuccess({ hasPhotos, onReset }) {
    const { state } = useContext(AppContext);
    const { photoContest } = state;

    return (
        <div>
            <div className="flex max-w-2xl mx-auto">
                <div>
                    <h2 className="text-brand">Izletna točka je bila uspešno oddana!</h2>
                    <p className="mt-4 text-lg">Objavljena bo, ko jo pregledajo in odobrijo naši administratorji. </p>
                    {hasPhotos && photoContest.state === 'ACTIVE' && (
                        <p>
                            S tem se bodo tvoja nova dodana točka in naložene fotografije{' '}
                            <strong>uvrstile v naš nagradni foto izbor lepot Slovenije</strong>.
                        </p>
                    )}

                    <div className="hidden sm:block mt-8">
                        <Button variant="contained" onClick={onReset}>
                            Dodaj še eno izletno idejo
                        </Button>
                        <div className="mt-4">
                            <Button variant="outlined" color="secondary" link="/">
                                Na domačo stran
                            </Button>
                        </div>
                    </div>
                </div>
                <div>
                    <img
                        src="/images/suggest-poi-success.svg"
                        alt="Izletna točka uspešno predlagana."
                        width="380"
                        className="max-w-full"
                    />
                </div>
            </div>
            <div className="sm:hidden mt-4">
                <Button variant="contained" onClick={onReset}>
                    Dodaj še eno izletno idejo
                </Button>
                <div className="mt-4">
                    <Button variant="outlined" color="secondary" link="/">
                        Na domačo stran
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default PoiSuggestionSuccess;
